import React, { useEffect, useState } from "react";
import "./projects.css";
import { trackPortfolioVisit, trackProjectInteraction, trackScrollDepth } from "../../utils/analytics";

function Projects() {
  useEffect(() => {
    // Track when Projects section is loaded
    trackPortfolioVisit('projects');

    const books = document.querySelectorAll(".book");

    if (window.innerWidth <= 1024) {
      // Apply on mobile and tablet devices
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Unflip all other books before flipping this one
              books.forEach((book) => book.classList.remove("visible"));
              entry.target.classList.add("visible");
            }
          });
        },
        { threshold: 0.9 }
      );

      books.forEach((book) => observer.observe(book));

      return () => observer.disconnect(); // Cleanup observer on unmount
    }

    // Track scroll depth
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;
      
      // Track significant scroll milestones
      if (scrollPercent > 0) {
        trackScrollDepth(scrollPercent, 'projects');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const githubRepo = "https://github.com/Lusa-mata?tab=repositories"; 

  const ViewProject2Link = "https://lusaduma.netlify.app/";
  const Project2Link = "https://github.com/Lusa-mata/My-Portfolio";
  
  const ViewProject3Link = "https://the-devs-checkers-game.netlify.app/";
  const Project3Link = "https://github.com/Lusa-mata/Checkers-game";

  const [demoOpen, setDemoOpen] = useState(false);

  return (
    <div>
      {/* Demo image popup */}
      {demoOpen && (
        <div className="demo-overlay" onClick={() => setDemoOpen(false)}>
          <button className="demo-close" onClick={() => setDemoOpen(false)}>✕</button>
          <img
            src="/images/Epilepsy dashboard blurred.png"
            alt="Epilepsy dashboard demo"
            className="demo-image"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
      {/*PROJECTS COMPLETED section*/}
      <div className="center">
        <section id="projects">
          <h1 className="heading">
            <span className="text autoplay"> DEPLOYED PROJECTS </span>
          </h1>
        </section>
      </div>

      <div className="cards-container-projects">
        {/* Epilepsy tracker project */}
        <div className="card-project1">
          <h2 style={{ textAlign: "center" }}>Epilepsy Tracker</h2>
          {/* <br></br> */}

          <div style={{ display: "flex", justifyContent: "center" }}>
            <div className="book">
              <p>
                The overall goal is to give a patient a single private tool to track, understand, 
                and report on their epilepsy — helping them and their doctors spot patterns, identify triggers, and monitor 
                medication adherence over time.<br></br>
                <br></br>
                  <button className="view-project-1" onClick={() => setDemoOpen(true)}>View Preview</button>




              </p>

              <div className="cover">
                <img src="/images/Epilepsy dashboard login.png" alt="Epilepsy tracker" />
              </div>
            </div>
          </div>

          

          
        </div>

        {/* Online portfolio project*/}
        <div className="card-project2">
          <h2 style={{ textAlign: "center" }}>Mark 1 Online Portfolio</h2>
          {/* <br></br> */}

          <div style={{ display: "flex", justifyContent: "center" }}>
            <div className="book">
              <p>
                This is the first portfolio I created when I was working at
                CapaCiTi. <br></br>
                {/* <br></br> It enabled me to learn more about coding standards and
                best practices used when coding. <br></br> */}
                <br></br>It showcases my skills and projects that I have done to
                date.

<a 
            href={ViewProject2Link} 
            target="_blank" 
            rel="noopener noreferrer"
            onClick={() => trackProjectInteraction('first_portfolio', 'view_demo')}
          >
            <div className="center">
              <button className="view-project-2">View Demo</button>
            </div>
          </a>


<a 
            href={Project2Link} 
            target="_blank" 
            rel="noopener noreferrer"
            onClick={() => trackProjectInteraction('first_portfolio', 'github_download')}
          >
            <div className="center">
              <button className="download-project-2">Download on GitHub</button>
            </div>
          </a>





              </p>

              <div className="cover">
                <img
                  src="/images/old portfolio.png"
                  alt="Old portfolio project"
                />
              </div>
            </div>
          </div>

          

          
        </div>

        {/* Checkers project */}
        <div className="card-project3">
          <h2 style={{ textAlign: "center" }}>Checkers Game</h2>
          {/* <br></br> */}

          <div style={{ display: "flex", justifyContent: "center" }}>
            <div className="book">
              <p>
                This is one of the games that we had created as a team during our time at
                CapaCiTi. 
                
                <br></br>
                <br></br>
                The game is a 2 player version of checkers which enables you to
                play with your friend at the leisure of your time.

<a 
            href={ViewProject3Link} 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <div className="center">
              <button className="view-project-3">View Demo</button>
            </div>
          </a>

<a 
            href={Project3Link} 
            target="_blank" 
            rel="noopener noreferrer"
            onClick={() => trackProjectInteraction('checkers_game', 'github_download')}
          >
            <div className="center">
              <button className="download-project-3">Download on GitHub</button>
            </div>
          </a>










              </p>

              <div className="cover">
                <img
                  src="/images/checkers image.png"
                  alt="Checkers game project"
                />
              </div>
            </div>
          </div>


          
        </div>
      </div>

      {/* More projects card*/}
      <div className="center">
        <div className="card-more">
          <div style={{ display: "flex", justifyContent: "center" }}>
            VIEW MORE PROJECTS ON GITHUB
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <a 
              href={githubRepo} 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={() => trackProjectInteraction('github_portfolio', 'view_all_projects')}
            >
              <input id="checkbox" type="checkbox" />
              <label className="switch" htmlFor="checkbox">
                <a href={githubRepo} target="_blank" rel="noopener noreferrer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    className="slider"
                  >
                    <path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V256c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"></path>
                  </svg>
                </a>
              </label>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
